class RecipeTileController {
    $onInit() {
        this.isJamieRecipe = this.recipe.TemplateName.toLowerCase() !== 'default';
    }
}

const recipeTileControllerComponentDefinition = {
    bindings: {
        recipe: '<',
    },
    controller: RecipeTileController,
    template: require('./recipe-tile.component.html').trim(),
};

module.exports = {
    RecipeTileController,
    recipeTileControllerComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/recipe/recipetile/recipe-tile.component.js